import Vue from 'vue'
import VueRouter from 'vue-router'
import Start from '../template/Start'
import store from '../store'
import User from '../views/User'
import NProgress from 'nprogress'
import Dashboard from '../views/Dashboard'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(() => {
  })
}

const routes = [
  {
    path: '/',
    component: Start,
    children: [
      {
        path: '',
        name: 'home',
        component: Dashboard,
        meta: { loading: true }
      },
      {
        path: 'user',
        name: 'user',
        component: User,
        children: [
          {
            path: 'files/:id',
            name: 'userfiles',
            component: () => import('../components/FileCollectionDialog'),
            props: true
          },
          {
            path: 'userpermissions/:id',
            name: 'userpermissions',
            component: () => import('../components/UserPermissionDialog'),
            props: true
          }]

      },
      {
        path: 'userregisterrequests',
        name: 'userregisterrequests',
        component: () => import('../views/UserRegisterRequests')
      },
      {
        path: 'settingsou',
        name: 'settingsou',
        component: () => import('../views/SettingsOu')
      },
      {
        path: 'rechte',
        name: 'rechte',
        component: () => import('../views/Rechte')
      },
      {
        path: 'rechtegruppen',
        name: 'rechtegruppen',
        component: () => import('../views/RechteGruppe')
      },
      {
        path: 'skill',
        name: 'skill',
        component: () => import('../views/Skill')
      },
      {
        path: 'filecategory',
        name: 'filecategory',
        component: () => import('../views/FileCategory')
      },
      {
        path: 'impressum',
        name: 'impressum',
        component: () => import('../views/Impressum')
      },
      {
        path: 'datenschutz',
        name: 'datenschutz',
        component: () => import('../views/Datenschutz')
      }, {
        path: 'profile',
        name: 'profile',
        component: () => import('../views/UserProfile'),
        meta: { loading: true }
      }, {
        path: 'deleteprofile',
        name: 'deleteprofile',
        component: () => import('../views/UserDelete')
      }, {
        path: 'password',
        name: 'password',
        component: () => import('../views/UserPassword')
      }, {
        path: 'qr',
        name: 'qr',
        component: () => import('../views/QrCodes')
      }, {
        path: 'info',
        name: 'info',
        component: () => import('../views/Task'),
        children: [
          {
            path: 'files/:id',
            name: 'infofiles',
            component: () => import('../components/FileCollectionDialog'),
            props: true
          }
        ]
      }, {
        path: 'myinfo',
        name: 'myinfo',
        component: () => import('../views/MyTask'),
        meta: { loading: true }
      },
      {
        path: 'userdates',
        name: 'userdates',
        component: () => import('../views/UserDates')
      },
      {
        path: 'datetype',
        name: 'datetype',
        component: () => import('../views/DateType')
      },
      {
        path: 'lionreads',
        name: 'lionreads',
        component: () => import('../views/LionReads')
      }
    ]
  },
  {
    path: '/scan/:token',
    name: 'scan',
    component: () => import('../views/LionValidateScan'),
    props: true
  },
  {
    path: '/register/:location?',
    name: 'register',
    component: () => import('../views/Register'),
    props: true
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login')
  },
  {
    path: '/pwvergessen',
    name: 'pwvergessen',
    component: () => import('../views/PasswordForgotten')
  },
  {
    path: '/pwreset',
    name: 'resetpassword',
    component: () => import('../views/ResetPassword')
  }, {
    path: '/seeyou',
    name: 'seeyou',
    component: () => import('../views/SeeYou')
  }, {
    path: '/datenschutzPublic',
    name: 'datenschutzPublic',
    component: () => import('../views/DatenschutzPublic')
  }, {
    path: '*',
    redirect: '/'
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

function checkPermission (to) {
  var MODULE = Vue.prototype.$module
  var PERMISSION = Vue.prototype.$permission

  to = to.toLowerCase()
  if (to.startsWith('/userdates')) {
    if (!store.getters.hasPermission(MODULE.IDENTIFIER_Userdates, PERMISSION.RECHT_Read)) {
      return false
    }
  } else if (to.startsWith('/user')) {
    if (!store.getters.hasPermission(MODULE.IDENTIFIER_User, PERMISSION.RECHT_Create) &&
      !store.getters.hasPermission(MODULE.IDENTIFIER_User, PERMISSION.RECHT_Update) &&
      !store.getters.hasPermission(MODULE.IDENTIFIER_User, PERMISSION.RECHT_Delete)) {
      return false
    }
  } else if (to.startsWith('/rechte') || to.startsWith('/skill')) {
    if (!store.getters.hasPermission(MODULE.IDENTIFIER_Stammdaten, PERMISSION.RECHT_Access)) {
      return false
    }
  } else if (to.startsWith('/settingsou')) {
    if (!store.getters.hasPermission(MODULE.IDENTIFIER_SettingsOu, PERMISSION.RECHT_Access)) {
      return false
    }
  } else if (to.startsWith('/datetype')) {
    if (!store.getters.hasPermission(MODULE.IDENTIFIER_Userdates, PERMISSION.RECHT_Create)) {
      return false
    }
  } else if (to.startsWith('/info')) {
    if (!store.getters.hasPermission(MODULE.IDENTIFIER_Info, PERMISSION.RECHT_Access)) {
      return false
    }
  } else if (to.startsWith('/myinfo')) {
    if (!store.getters.hasPermission(MODULE.IDENTIFIER_Info, PERMISSION.RECHT_Access_Own)) {
      return false
    }
  } else if (to.startsWith('/profile') || to.startsWith('/deleteprofile')) {
    if (!store.getters.hasPermission(MODULE.IDENTIFIER_MYPROFILE, PERMISSION.RECHT_Access_Own)) {
      return false
    }
  } else if (to.startsWith('/password')) {
    if (!store.getters.hasPermission(MODULE.IDENTIFIER_MYPASSWORD, PERMISSION.RECHT_Access_Own)) {
      return false
    }
  } else if (to.startsWith('/lionreads')) {
    if (!store.getters.hasPermission(MODULE.IDENTIFIER_Lion, PERMISSION.RECHT_Read)) {
      return false
    }
  }

  return true
}

router
  .beforeEach((to, from, next) => {
    NProgress.start()
    store.dispatch('menu/setLoading', false)

    if (to.path.includes('/scan')) {
      next()
      return true
    }

    if (to.path.includes('/register')) {
      store.dispatch('logout')
      next()
      return true
    }

    if (to.path.includes('/datenschutzPublic')) {
      store.dispatch('datenschutzPublic')
      next()
      return true
    }

    if (to.path.includes('/seeyou')) {
      store.dispatch('logout')
      next()
      return true
    }

    if (to.path === '/login') {
      store.dispatch('logout')
      next()
      return true
    }

    if (to.path.includes('/pwvergessen')) {
      store.dispatch('logout')
      next()
      return true
    }

    if (to.path.includes('/pwreset')) {
      store.dispatch('logout')
      next()
      return true
    }

    if (to.path) {
      console.log('ROUTER ' + to.path)
      if (to.path !== '/login' && (!store.getters.getToken || !store.getters.getUser || !store.getters.getLocation)) {
        store.dispatch('fetchToken').then(function (data) {
          if (!checkPermission(to.path)) {
            NProgress.done()
            return true
          }

          if (to.meta.loading) {
            store.dispatch('menu/setLoading', true)
          }
          next()
          store.dispatch('menu/setActive', { path: to.path })
        })
      } else {
        if (!checkPermission(to.path)) {
          NProgress.done()
          return true
        }

        if (to.meta.loading) {
          store.dispatch('menu/setLoading', true)
        }
        next()
        store.dispatch('menu/setActive', { path: to.path })
      }
    }
  })

router.afterEach(() => {
  NProgress.done()
})
export default router
